<template>
  <div>
    <h3 class="gray--text">{{ $t('pageLogin.title') }}</h3>
    <v-form v-model="valid">
      <v-row class="no-gutters">
        <v-col class="col-3">
          <v-subheader>Email</v-subheader>
        </v-col>
        <v-col class="col-8">
          <v-text-field
            solo
            flat
            v-model="email"
            label="Email"
            :rules="[rules.email, rules.required]"
            required
            :placeholder="$t('pageLogin.placeholdEmail')"
            background-color="#F7F7F7"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="no-gutters">
        <v-col class="col-3">
          <v-subheader>{{ $t('pageLogin.labelPassword') }}</v-subheader>
        </v-col>
        <v-col class="col-8">
          <v-text-field
            solo
            flat
            v-model="password"
            :append-icon="show1 ? 'visibility' : 'visibility_off'"
            :type="show1 ? 'text' : 'password'"
            label="Senha"
            :rules="[rules.required]"
            required
            :placeholder="$t('pageLogin.placeholdPassword')"
            @click:append="show1 = !show1"
            background-color="#F7F7F7"
            @keyup.enter="login()"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <p class="body-1 text-center gray--text">
      {{ $t('pageLogin.mensagem') }}
      <ForgotPassword />
    </p>

    <v-row class="justify-center">
      <v-col class="col-5 col-md-4">
        <v-btn
          color="secondary"
          depressed
          large
          block
          @click="login()"
          :loading="loader"
          :disabled="!valid"
          >ENTRAR</v-btn
        >
      </v-col>
    </v-row>

    <v-row class="justify-center grey lighten-4 py-4 mt-5">
      <v-col class="col-8">
        <p class="text-center mb-0 gray--text">Não possui uma conta?</p>
        <p class="text-center mb-0">
          <router-link
            :to="
              mode === 'psychologist' ? { name: 'CadastroPsicologo' } : { name: 'CadastroPaciente' }
            "
            class="text-uppercase"
            >{{ $t('pageLogin.cadastrar') }}
          </router-link>
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LoginService from '../services/general';
import ForgotPassword from './ForgotPassword';

export default {
  name: 'ComponentLogin',
  components: {
    ForgotPassword,
  },
  props: {
    mode: {
      type: String,
      default: 'psychologist',
    },
  },
  data() {
    return {
      valid: false,
      show1: false,
      loader: false,
      email: '',
      password: '',
      rules: {
        required: (value) => !!value || 'Esse campo é obrigatório.',
        email: (value) => {
          const pattern = /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*/;
          return pattern.test(value) || 'E-mail invalido.';
        },
      },
    };
  },
  methods: {
    async login() {
      this.loader = true;
      try {
        const { data } = await LoginService.login(this.email.trim(), this.password);
        localStorage.setItem('user-token', data.token);
        localStorage.setItem('user-id', data.id);
        localStorage.setItem('user-category', data.category);
        localStorage.setItem('user-data', JSON.stringify(data.user));
        this.emitData({
          isLogged: true,
          msg: 'Login efetuado com sucesso!',
        });
      } catch (err) {
        let msg;
        if (err.response.data.non_field_errors) {
          // eslint-disable-next-line prefer-destructuring
          msg = err.response.data.non_field_errors[0];
        } else if (err.response.data.detail) {
          msg = err.response.data.detail;
        } else {
          msg = err.response.data;
        }
        this.emitData({
          isLogged: false,
          msg,
        });
      } finally {
        this.loader = false;
      }
    },
    emitData(v) {
      this.$emit('data', v);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-subheader {
  background-color: #f7f7f7;
}
</style>
